import { ShoppingBasket } from "lucide-react";
import React from "react";


import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function FooterCard12() {
  return (<>
    <footer className="med-footer-fc-12">

      {/* ---------- DARK TOP SECTION ---------- */}
      <div className="med-footer-fc-12-top">
        <div className="med-footer-fc-12-container">

          {/* Recent Posts */}
          <div className="footer-fc-12-col">
            <div className="footer-fc-12-col">
          <h3 className="footer-fc-12-heading">CONTACT INFO</h3>

          <p className="footer-fc-12-item">Address: Lorem ipsum dolor sit</p>
          <p className="footer-fc-12-item">Email: info@sports.com</p>
          <p className="footer-fc-12-item">Phone: 123456789</p>
        </div>
          </div>

          {/* Newsletter */}
          <div className="footer-fc-12-col">
            <h3 className="footer-fc-12-title">Newsletter</h3>
            <div className="footer-fc-12-title-underline"></div>

            <p className="newsletter-fc-12-text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Accusamus et odio dignissimos ducimus blanditiis praesentium.
            </p>

            <div className="newsletter-fc-12-socials">
              <div className="social-circle-placeholder"> <FaFacebookF />
                         </div>
              <div className="social-circle-placeholder"> <FaTwitter />
                          </div>
              <div className="social-circle-placeholder"><FaInstagram />
                          </div>
              <div className="social-circle-placeholder"><FaLinkedinIn />
                         </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- BLUE BOTTOM SECTION ---------- */}
      <div className="med-footer-fc-12-bottom">
        <div className=" bottom-inner-fc-12">

          <div className="footer-fc-12-logo-fc-12">
            <div className="logo-fc-12-placeholder"><ShoppingBasket size={50}/></div>
            <h2 className="logo-fc-12-text">Medical Hospital</h2>
          </div>

          <div className="bottom-links-fc-12">
            <a href="#">Contact</a>
            <a href="#">Page</a>
            <a href="#">Blog</a>
            <a href="#">Account</a>
            <a href="#">Checkout</a>
            <a href="#">Cart</a>
          </div>

        </div>

        <p className="footer-fc-12-copy">
          Medical WordPress Theme 2025 — Designed & Developed by You
        </p>
      </div>
    </footer>
    <style>{`/* ============ FOOTER WRAPPER ============ */
    
.footer-fc-12-col {
  flex: 1;
  min-width: 220px;
}
  
.footer-fc-12-heading {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}

.footer-fc-12-item {
  opacity: 0.85;
  margin: 4px 0;
}

/* News Items */
.news-fc-12-item {
  margin-bottom: 18px;
}

.med-footer-fc-12 {
  width: 100%;
  margin-top: 60px;
  font-family: Arial, sans-serif;
}

/* ========================================================= */
/*                DARK TOP SECTION                           */
/* ========================================================= */
.med-footer-fc-12-top {
  
  padding: 0px 50px;
  color: #fff;
}

.med-footer-fc-12-container {
  width: 80%;background: #2d3240;position:relative;bottom:-35px;
  max-width: 1300px;
  padding:15px 20px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.footer-fc-12-logo-fc-12{margin-top:15px;display:flex;justify-content:center;gap:20px;align-items:center;}
/* Two columns */
.footer-fc-12-col {
  flex: 1;
  min-width: 280px;
}

/* Titles */
.footer-fc-12-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

.footer-fc-12-title-underline {
  width: 40px;
  height: 3px;
  background: rgba(144, 202, 249,1);
  margin-bottom: 20px;
}

/* ================= Recent Posts ================== */
.recent-post-fc-12 {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.post-fc-12-img-placeholder {
  width: 50px;
  height: 50px;
  background: #3c4255;
  border-radius: 50%;
  margin-right: 15px;
}

.post-fc-12-info .post-fc-12-title {
  font-size: 14px;
  margin: 0;
}

.post-fc-12-info .post-fc-12-date {
  font-size: 12px;
  opacity: 0.7;
}

/* ================= Newsletter ================== */
.newsletter-fc-12-text {
  font-size: 14px;
  opacity: 0.85;
  line-height: 1.5;
  margin-bottom: 20px;
}

.newsletter-fc-12-socials {
  display: flex;
  gap: 12px;
}

.social-circle-placeholder {
  width: 38px;
  height: 38px;display:flex;justify-content:center;align-items:center;
  background: #3c4255;
  border-radius: 50%;
}

/* ========================================================= */
/*                BLUE BOTTOM SECTION                        */
/* ========================================================= */
.med-footer-fc-12-bottom {
  background: rgba(144, 202, 249,1);
  padding: 40px 0 20px 0;
  text-align: center;
  color: #fff;
}

.bottom-inner-fc-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}

/* Logo block */
.logo-fc-12-placeholder {
  width: 60px;display:flex;justify-content:center;align-items:center;
  height: 60px;
  background: #ffffff55;
  border-radius: 10px;
}

.logo-fc-12-text {
  margin-top: 10px;
  font-size: 20px;
}

/* Bottom links */
.bottom-links-fc-12 {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.bottom-links-fc-12 a {
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}

.footer-fc-12-copy {
  margin-top: 25px;
  opacity: 0.8;
  font-size: 14px;
}

/* ============ RESPONSIVE ============ */
@media (max-width: 900px) {
  .med-footer-fc-12-container {
    flex-direction: column;
    text-align: left;
  }

  .bottom-inner-fc-12 {
    text-align: center;
  }
}
`}</style>
  </>);
}
